module.exports = __webpack_public_path__ + "img/14-full-sm.027c2ac7.jpg";